module.exports = "export function fibonacci(n: i32): i32 {\n  if (n == 0)\n    return 0;\n  if (n == 1)\n    return 1;\n  return fibonacci(n - 1) + fibonacci(n - 2);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./examples/walt/fibonacci.walt
// module id = 927
// module chunks = 0